/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/10
 * Description: 文件描述
 */
let m = {},
  protocol = 'http://';
/*
 *
 */

export default {
  state: {
    // 内网地址：
    // url: "http://192.168.199:5005/api/",
    // scaleUrl: 'http://192.168.199:5005/',

    // 陈雷服务器地址
    // url: 'http://47.109.34.109:5001/api/',
    


// 线上地址：
    url: "https://hosapi.lanyunxinli.com/api/",
    scaleUrl: 'https://hosapi.lanyunxinli.com/',
    Temolateurl: "https://fileoss.lanyunxinli.com/file/",
    fileurl: 'https://fileoss.lanyunxinli.com/', // 签名地址
    qrcodeUrl: "http://answer.lanyunxinli.com/#",



    // 铜梁区人民医院内网地址：
    // url: "http://172.16.3.56:5000/api/", // 铜梁区人民医院内网ip
    // Temolateurl: "http://172.16.3.56:5000/file/",
    // qrcodeUrl: "http://172.16.3.56:5000/#",
    // 广安-武胜人民医院  毛文国医院
    // url: "http://192.168.3.94:5000/api/",
    //  Temolateurl: "http://192.168.3.94:5000/file/",

    //  qrcodeUrl: "http://192.168.3.94:5000/mobile/index.html#",

    // 本地地址：
    // url: " http://192.168.0.196:5000/api/",

    // qrcodeUrl:"http://13558565520.zicp.vip/mobile/index.html#",
    //qrcodeUrl: "http://192.168.0.196:5000/mobile/index.html#",
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    rightNav: {},
    config: {},
    tabnavBox: [{
      title: 'home',
      path: '/index'
    }]
  },
  mutations: {
    seturl(state, url) {
      state.url = url
    },
    setConfig(state, config) {
      state.config = config
    },
    addTab(state, arg) {

      state.isActive = arg.path
      for (let i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false
        }
      }
      state.tabnavBox.push({
        title: arg.title,
        path: arg.path
      })
    },
    openMenu(state, arg) {
      state.rightNav = arg
    },
    removeTab(state, arg) {
      let index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path
      })
      state.tabnavBox.splice(index, 1)
      if (arg.tabItem.path === arg.fullPath) {
        let tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1]
        arg.router.push(tabActive.path)
      }
      if (arg.fullPath.indexOf('IDNumber')) {
        let tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1]
        arg.router.push(tabActive.path)
      }
    },
    removeOtherTab(state, arg) {
      state.tabnavBox = [{
        title: 'home',
        path: '/index'
      }]
      if (arg.all) {
        arg.router.push('/index')
        return false
      }
      state.tabnavBox.push(arg.tabItem)
      arg.router.push(arg.tabItem.path)
    },
    collapse(state, arg) {
      state.isCollapse = !state.isCollapse
      if (state.logoShow) {
        setTimeout(function () {
          state.logoShow = false
        }, 300)
      } else {
        state.logoShow = true
      }
    },
  },
  actions: {
    addTab({
      commit
    }, arg) {
      commit('addTab', arg)
    },
    openMenu({
      commit
    }, arg) {
      commit('openMenu', arg)
    },
    removeTab({
      commit
    }, arg) {
      commit('removeTab', arg)
    },
    removeOtherTab({
      commit
    }, arg) {
      commit('removeOtherTab', arg)
    },
    collapse({
      commit
    }, arg) {
      commit('collapse', arg)
    },
    setConfig({
      commit
    }, arg) {
      commit('setConfig', arg)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/layout/index.js